import React, { useEffect, useState } from "react";
import { games } from "../data/staticData"; // Import static games data

const GameSelector: React.FC<{ selectedCountry: string, onGameSelect: (game: string) => void }> = ({ selectedCountry, onGameSelect }) => {
  const [availableGames, setAvailableGames] = useState<{ component: string, symbol: string }[]>([]);

  useEffect(() => {
    // Load games for the selected country from the static data
    setAvailableGames(games[selectedCountry] || []);
  }, [selectedCountry]);

  // Organize games into categories
  const numberGames = availableGames.filter(game => game.component.includes("num_range"));
  const mathGames = availableGames.filter(game => game.component.includes("math"));
  const phoneGame = availableGames.find(game => game.component === "phone_numbers");
  const timeGame = availableGames.find(game => game.component === "time_of_day");

  return (
    <div className="game-selector">
      <h1>Lost Abroad Minis</h1>
      <h3>Select a Game</h3>
      
      <div className="game-grid">
        {numberGames.map((game) => (
          <button key={game.component} className="game-btn" onClick={() => onGameSelect(game.component)}>
            {game.symbol}
          </button>
        ))}
        {mathGames.map((game) => (
          <button key={game.component} className="game-btn" onClick={() => onGameSelect(game.component)}>
            {game.symbol}
          </button>
        ))}
        {phoneGame && (
          <button key={phoneGame.component} className="game-btn phone-btn" onClick={() => onGameSelect(phoneGame.component)}>
            {phoneGame.symbol}
          </button>
        )}
        {timeGame && (
          <button key={timeGame.component} className="game-btn phone-btn" onClick={() => onGameSelect(timeGame.component)}>
            {timeGame.symbol}
          </button>
        )}
      </div>
    </div>
  );
};

export default GameSelector;
